var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "click-outside",
          rawName: "v-click-outside",
          value: _vm.handleOutsideClick,
          expression: "handleOutsideClick",
        },
      ],
      class: { open: _vm.menu.isOpen || _vm.menu.hoverActive },
      attrs: { id: "sidebar" },
    },
    [
      _c("ModulesDropdown", {
        class: { active: _vm.moduleActive },
        attrs: { active: _vm.moduleActive },
        on: {
          selected: function () {
            return (_vm.moduleActive = false)
          },
          close: function () {
            return _vm.moduleActive ? (_vm.moduleActive = false) : null
          },
        },
      }),
      _vm._v(" "),
      _vm.repSettingsModal
        ? _c(
            "Modal2",
            {
              attrs: {
                "class-name": "rep-settings-modal",
                title: _vm.$t("message.represantativeSettings"),
                "show-footer": false,
              },
              on: {
                cancel: function ($event) {
                  _vm.repSettingsModal = false
                },
              },
            },
            [_c("RepresentativeSettings")],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "content" }, [
        _vm.permissions.length || _vm.isAdmin
          ? _c(
              "div",
              {
                key: "menu-" + _vm.forceRenderCount,
                ref: "scrollRef",
                staticClass: "menu-list",
                style: {
                  height:
                    _vm.modules.length > 0
                      ? "calc(100% - 230px)"
                      : "calc(100% - 190px)",
                },
                on: {
                  mouseenter: _vm.mouseEnterStart,
                  mouseleave: _vm.mouseLeaveStart,
                },
              },
              [
                _vm._l(_vm.allowedRoutes(), function (item) {
                  return [
                    _c(
                      "a-tooltip",
                      {
                        key: item.key,
                        attrs: {
                          title: item.title,
                          placement: "right",
                          overlayClassName:
                            _vm.menu.isOpen || _vm.menu.hoverActive
                              ? " hiddenToolTip"
                              : "",
                        },
                        on: { click: _vm.closeMenu },
                      },
                      [
                        _c(
                          "router-link",
                          {
                            staticClass: "menu-list-item",
                            attrs: { to: item.path },
                            nativeOn: {
                              click: function ($event) {
                                return _vm.handleMenuClick(item, $event)
                              },
                            },
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "menu-list-item-icon" },
                              [
                                item.isNew
                                  ? _c("div", { staticClass: "new-tag" }, [
                                      _vm._v("NEW"),
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                item.antIcon
                                  ? _c("a-icon", {
                                      staticStyle: { "font-size": "20px" },
                                      style: {
                                        color: _vm.bugExist
                                          ? "red !important"
                                          : "#9ba2b6 !important",
                                      },
                                      attrs: { type: item.antIcon },
                                    })
                                  : _c(item.icon, {
                                      tag: "component",
                                      staticClass: "myIcon",
                                    }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "menu-list-item-title" }, [
                              _vm._v(_vm._s(item.title)),
                            ]),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]
                }),
                _vm._v(" "),
                _vm._l(_vm.visibleWebTabs, function (tab) {
                  return [
                    _c(
                      "a-tooltip",
                      {
                        key: "webtab-" + tab._id,
                        attrs: {
                          title: tab.description || tab.name,
                          placement: "right",
                          overlayClassName:
                            _vm.menu.isOpen || _vm.menu.hoverActive
                              ? " hiddenToolTip"
                              : "",
                        },
                        on: { click: _vm.closeMenu },
                      },
                      [
                        _c(
                          "router-link",
                          {
                            staticClass: "menu-list-item",
                            attrs: { to: "/webtab/" + tab._id },
                            nativeOn: {
                              click: function ($event) {
                                return _vm.handleWebTabClick(tab, $event)
                              },
                            },
                          },
                          [
                            _c("div", { staticClass: "menu-list-item-icon" }, [
                              _c(
                                "span",
                                {
                                  staticClass: "material-icons",
                                  style: {
                                    color: tab.iconColor || "#6b727d",
                                    fontSize: "20px",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(tab.icon) +
                                      "\n                            "
                                  ),
                                ]
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "menu-list-item-title" }, [
                              _vm._v(_vm._s(tab.name)),
                            ]),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]
                }),
              ],
              2
            )
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "dropdown-control" }, [
          _c(
            "div",
            {
              staticClass: "dropdown-control-items",
              on: {
                mouseenter: _vm.mouseEnterStart,
                mouseleave: _vm.mouseLeaveStart,
              },
            },
            [
              _vm.modules.length > 0
                ? _c(
                    "a-tooltip",
                    {
                      attrs: {
                        title: _vm.$t("modules.modules"),
                        placement: "right",
                        overlayClassName:
                          _vm.menu.isOpen || _vm.menu.hoverActive
                            ? " hiddenToolTip"
                            : "",
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "dropdown-control-item modules",
                          on: {
                            click: function ($event) {
                              _vm.moduleActive = !_vm.moduleActive
                            },
                          },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "dropdown-control-item-icon" },
                            [
                              _c("ModuleIcon", {
                                tag: "component",
                                staticClass: "myIcon",
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "information-text" }, [
                            _vm._v(_vm._s(_vm.$t("modules.modules"))),
                          ]),
                        ]
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "a-tooltip",
                {
                  attrs: {
                    title: _vm.$t("message.integrations"),
                    placement: "right",
                    overlayClassName:
                      _vm.menu.isOpen || _vm.menu.hoverActive
                        ? " hiddenToolTip"
                        : "",
                  },
                },
                [
                  _vm.isAllowed("integrations.view")
                    ? _c(
                        "router-link",
                        {
                          staticClass: "dropdown-control-item integrations",
                          attrs: { to: "/integrations" },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "dropdown-control-item-icon" },
                            [
                              _c("IntegrationIcon", {
                                tag: "component",
                                staticClass: "myIcon",
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "information-text" }, [
                            _vm._v(_vm._s(_vm.$t("message.integrations"))),
                          ]),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "a-tooltip",
                {
                  attrs: {
                    title: _vm.$t("report.reports"),
                    placement: "right",
                    overlayClassName:
                      _vm.menu.isOpen || _vm.menu.hoverActive
                        ? " hiddenToolTip"
                        : "",
                  },
                },
                [
                  _vm.isAllowed("report.get")
                    ? _c(
                        "router-link",
                        {
                          staticClass: "dropdown-control-item integrations",
                          attrs: { to: "/report-new" },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "dropdown-control-item-icon" },
                            [
                              _c("DetailReports", {
                                tag: "component",
                                staticClass: "myIcon",
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "information-text" }, [
                            _vm._v(_vm._s(_vm.$t("report.reports"))),
                          ]),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "a-tooltip",
                {
                  attrs: {
                    title: _vm.$t("message.settings"),
                    placement: "right",
                    overlayClassName:
                      _vm.menu.isOpen || _vm.menu.hoverActive
                        ? " hiddenToolTip"
                        : "",
                  },
                },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "dropdown-control-item settings",
                      attrs: { to: "/settings" },
                      on: { click: _vm.closeMenu },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "dropdown-control-item-icon" },
                        [
                          _c("SettingsIcon", {
                            tag: "component",
                            staticClass: "myIcon",
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "information-text" }, [
                        _vm._v(_vm._s(_vm.$t("message.settings"))),
                      ]),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("Popover", {
                attrs: {
                  placement: "rightBottom",
                  "class-name": "user-popover",
                  trigger: "click",
                },
                scopedSlots: _vm._u([
                  {
                    key: "content",
                    fn: function () {
                      return [
                        _vm.user && !_vm.isAdmin
                          ? _c(
                              "div",
                              { staticClass: "dropdown-control-item profile" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "dropdown-control-item-icon profile-avatar",
                                    class: _vm.user.status.toLowerCase(),
                                  },
                                  [
                                    _c("div", {
                                      staticClass: "profile-avatar-badge",
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "avatar" },
                                      [
                                        !_vm.user.gravatar
                                          ? _c("a-avatar", {
                                              attrs: {
                                                size: 30,
                                                icon: "user",
                                                username: _vm.user.name,
                                                round: false,
                                                "background-color": "",
                                              },
                                            })
                                          : _vm.user.gravatar
                                          ? _c("img", {
                                              attrs: {
                                                src: _vm.user.gravatar,
                                                alt: _vm.user.name,
                                              },
                                            })
                                          : _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.user.name
                                                    .substr(0, 1)
                                                    .toUpperCase()
                                                )
                                              ),
                                            ]),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "information-text" }, [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(
                                        _vm.user.name.charAt(0).toUpperCase() +
                                          _vm.nameSorter(_vm.user.name.slice(1))
                                      ) +
                                      "\n                            "
                                  ),
                                ]),
                              ]
                            )
                          : _vm._e(),
                      ]
                    },
                    proxy: true,
                  },
                  {
                    key: "popover-content",
                    fn: function () {
                      return [
                        _c(
                          "div",
                          { staticClass: "user-popover-content" },
                          [
                            _vm.user && !_vm.isAdmin
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "user-popover-content-profile",
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "user-popover-content-profile-content",
                                        class: _vm.user.status.toLowerCase(),
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "user-popover-content-profile-content-avatar",
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "avatar" },
                                              [
                                                !_vm.user.gravatar
                                                  ? _c("a-avatar", {
                                                      attrs: {
                                                        size: 30,
                                                        icon: "user",
                                                        username: _vm.user.name,
                                                        round: false,
                                                        "background-color": "",
                                                      },
                                                    })
                                                  : _vm.user.gravatar
                                                  ? _c("img", {
                                                      attrs: {
                                                        src: _vm.user.gravatar,
                                                        alt: _vm.user.name,
                                                      },
                                                    })
                                                  : _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.user.name
                                                            .substr(0, 1)
                                                            .toUpperCase()
                                                        )
                                                      ),
                                                    ]),
                                              ],
                                              1
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "user-popover-content-profile-content-name",
                                          },
                                          [
                                            _vm._v(
                                              "\n                                        " +
                                                _vm._s(
                                                  _vm.user.name
                                                    .charAt(0)
                                                    .toUpperCase() +
                                                    _vm.nameSorter(
                                                      _vm.user.name.slice(1)
                                                    )
                                                ) +
                                                "\n                                    "
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "user-popover-content-profile-options",
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "user-popover-content-profile-options-logout",
                                            on: { click: _vm.logout },
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "material-icons" },
                                              [_vm._v("logout")]
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c("Popover", {
                              attrs: {
                                placement: "rightBottom",
                                "class-name": "user-popover",
                                trigger: "hover",
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "content",
                                  fn: function () {
                                    return [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "user-popover-content-item",
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "user-popover-content-item-icon",
                                            },
                                            [
                                              _c(
                                                _vm.status[
                                                  _vm.user.status.toLowerCase()
                                                ].icon,
                                                { tag: "component" }
                                              ),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "user-popover-content-item-text",
                                            },
                                            [
                                              _vm._v(
                                                "\n                                            " +
                                                  _vm._s(
                                                    _vm.status[
                                                      _vm.user.status.toLowerCase()
                                                    ].text
                                                  ) +
                                                  "\n                                        "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "user-popover-content-item-arrow",
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "material-icons",
                                                },
                                                [_vm._v("chevron_right")]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  },
                                  proxy: true,
                                },
                                {
                                  key: "popover-content",
                                  fn: function () {
                                    return [
                                      _c(
                                        "div",
                                        { staticClass: "user-popover-content" },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "user-popover-content-item",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.setStatus("Online")
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "user-popover-content-item-icon",
                                                },
                                                [_c("Online")],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "user-popover-content-item-text",
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                                " +
                                                      _vm._s(
                                                        _vm.$t("message.online")
                                                      ) +
                                                      "\n                                            "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "user-popover-content-item",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.setStatus("Away")
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "user-popover-content-item-icon",
                                                },
                                                [_c("Away")],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "user-popover-content-item-text",
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                                " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "message.beRightBack"
                                                        )
                                                      ) +
                                                      "\n                                            "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "user-popover-content-item",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.setStatus("Busy")
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "user-popover-content-item-icon",
                                                },
                                                [_c("Busy")],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "user-popover-content-item-text",
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                                " +
                                                      _vm._s(
                                                        _vm.$t("message.busy")
                                                      ) +
                                                      "\n                                            "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "user-popover-content-item",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.setStatus(
                                                    "Offline"
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "user-popover-content-item-icon",
                                                },
                                                [_c("Offline")],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "user-popover-content-item-text",
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                                " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "message.offline"
                                                        )
                                                      ) +
                                                      "\n                                            "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ]),
                            }),
                            _vm._v(" "),
                            _c("Popover", {
                              attrs: {
                                placement: "rightBottom",
                                "class-name": "user-popover",
                                trigger: "click",
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "content",
                                  fn: function () {
                                    return [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "user-popover-content-item language-content",
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "user-popover-content-item-icon",
                                            },
                                            [
                                              _c("country-flag", {
                                                class: {
                                                  selected:
                                                    _vm.language.code ===
                                                    _vm.$i18n.locale,
                                                },
                                                attrs: {
                                                  country:
                                                    _vm.language.code === "en"
                                                      ? "us"
                                                      : _vm.language.code ===
                                                        "ar"
                                                      ? "sa"
                                                      : _vm.language.code,
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "user-popover-content-item-text",
                                            },
                                            [
                                              _vm._v(
                                                "\n                                            " +
                                                  _vm._s(
                                                    _vm.$t("message.changeLang")
                                                  ) +
                                                  "\n                                        "
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  },
                                  proxy: true,
                                },
                                {
                                  key: "popover-content",
                                  fn: function () {
                                    return _vm._l(
                                      _vm.languages,
                                      function (language, index) {
                                        return _c(
                                          "div",
                                          {
                                            key: "lang-" + index,
                                            staticClass:
                                              "user-popover-content-item language-content",
                                            on: {
                                              click: function ($event) {
                                                return _vm.setCurrentLanguage(
                                                  language.code
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "user-popover-content-item-icon",
                                              },
                                              [
                                                _c("country-flag", {
                                                  class: {
                                                    selected:
                                                      language.code ===
                                                      _vm.$i18n.locale,
                                                  },
                                                  attrs: {
                                                    country:
                                                      language.code === "en"
                                                        ? "us"
                                                        : language.code === "ar"
                                                        ? "sa"
                                                        : language.code,
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "user-popover-content-item-text",
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                            " +
                                                    _vm._s(language.name) +
                                                    "\n                                        "
                                                ),
                                              ]
                                            ),
                                          ]
                                        )
                                      }
                                    )
                                  },
                                  proxy: true,
                                },
                              ]),
                            }),
                            _vm._v(" "),
                            _c(
                              "router-link",
                              {
                                staticClass: "user-popover-content-item",
                                attrs: { to: "/profile" },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "user-popover-content-item-icon",
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "material-icons" },
                                      [_vm._v("settings")]
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "user-popover-content-item-text",
                                  },
                                  [
                                    _vm._v(
                                      "\n                                    " +
                                        _vm._s(
                                          _vm.$t(
                                            "message.represantativeSettings"
                                          )
                                        ) +
                                        "\n                                "
                                    ),
                                  ]
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "user-popover-content-item",
                                on: { click: _vm.logout },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "user-popover-content-item-icon",
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "material-icons text-danger",
                                      },
                                      [_vm._v("logout")]
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "user-popover-content-item-text text-danger",
                                  },
                                  [
                                    _vm._v(
                                      "\n                                    " +
                                        _vm._s(_vm.$t("message.logout")) +
                                        "\n                                "
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dropdown-control-item btn-sidebar-navigation",
              on: { click: _vm.clickItem, touchend: _vm.clickItem },
            },
            [
              _c("div", { staticClass: "information-text" }, [
                _vm._v(_vm._s(_vm.$t("message.showHide"))),
              ]),
              _vm._v(" "),
              _c(
                "div",
                [
                  _vm.menu.isOpen || _vm.menu.hoverActive
                    ? _c("RightSidebarIcon")
                    : _c("LeftSidebarIcon"),
                ],
                1
              ),
            ]
          ),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }